// Datos mock centralizados para toda la aplicación

export const mockUsers = [
  {
    id: 1,
    email: 'admin@educapp.cl',
    password: 'admin123',
    role: 'administrador',
    name: 'Juan Carlos Pérez',
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=40&h=40&fit=crop&crop=face',
    phone: '+56 9 8765 4321',
    rut: '12.345.678-9',
    permissions: ['all'],
    department: 'Administración',
    active: true,
    createdAt: '2024-01-15T09:00:00.000Z'
  },
  {
    id: 2,
    email: 'gestor@educapp.cl',
    password: 'gestor123',
    role: 'gestor',
    name: 'Ana María González',
    avatar: 'https://images.unsplash.com/photo-1494790108755-2616c3c611cb?w=40&h=40&fit=crop&crop=face',
    phone: '+56 9 7654 3210',
    rut: '13.456.789-0',
    permissions: ['users', 'courses', 'projects', 'calendar', 'reports'],
    department: 'Coordinación Académica',
    active: true,
    createdAt: '2024-02-01T10:30:00.000Z'
  },
  {
    id: 3,
    email: 'profesor@educapp.cl',
    password: 'prof123',
    role: 'profesor',
    name: 'María José Rodríguez',
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=40&h=40&fit=crop&crop=face',
    phone: '+56 9 6543 2109',
    rut: '14.567.890-1',
    subjects: ['Ciencias Naturales', 'Biología'],
    courses: ['7° Básico A', '7° Básico B', '8° Básico A'],
    permissions: ['projects', 'evaluations', 'messages', 'grades'],
    department: 'Ciencias',
    specialization: 'Biología y Ciencias Naturales',
    active: true,
    createdAt: '2024-01-20T08:15:00.000Z'
  },
  {
    id: 4,
    email: 'alumno@educapp.cl',
    password: 'alum123',
    role: 'alumno',
    name: 'Carlos Eduardo Silva',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=40&h=40&fit=crop&crop=face',
    phone: '+56 9 5432 1098',
    rut: '20.123.456-7',
    course: '8° Básico A',
    parentId: 5,
    birthDate: '2010-03-15',
    address: 'Av. Los Leones 1234, Providencia',
    permissions: ['projects', 'grades', 'messages'],
    active: true,
    createdAt: '2024-03-01T14:00:00.000Z'
  },
  {
    id: 5,
    email: 'apoderado@educapp.cl',
    password: 'apod123',
    role: 'apoderado',
    name: 'Patricia Elena Morales',
    avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=40&h=40&fit=crop&crop=face',
    phone: '+56 9 4321 0987',
    rut: '15.678.901-2',
    children: [
      { id: 4, name: 'Carlos Eduardo Silva', course: '8° Básico A', relationship: 'Madre' }
    ],
    profession: 'Ingeniera Comercial',
    workplace: 'Banco de Chile',
    permissions: ['messages', 'payments', 'reports', 'grades'],
    active: true,
    createdAt: '2024-03-01T14:30:00.000Z'
  }
];

export const mockCourses = [
  {
    id: 1,
    name: '7° Básico A',
    level: '7° Básico',
    section: 'A',
    students: 32,
    homeRoomTeacher: {
      id: 3,
      name: 'María José Rodríguez'
    },
    subjects: [
      { id: 1, name: 'Matemáticas', teacherId: 6, hours: 6 },
      { id: 2, name: 'Lenguaje y Comunicación', teacherId: 7, hours: 6 },
      { id: 3, name: 'Ciencias Naturales', teacherId: 3, hours: 4 },
      { id: 4, name: 'Historia y Geografía', teacherId: 8, hours: 4 },
      { id: 5, name: 'Inglés', teacherId: 9, hours: 4 },
      { id: 6, name: 'Educación Física', teacherId: 10, hours: 3 },
      { id: 7, name: 'Arte', teacherId: 11, hours: 2 }
    ],
    schedule: {
      monday: ['Matemáticas', 'Lenguaje', 'Ciencias', 'Historia', 'Ed. Física'],
      tuesday: ['Lenguaje', 'Matemáticas', 'Inglés', 'Arte', 'Ciencias'],
      wednesday: ['Historia', 'Matemáticas', 'Lenguaje', 'Inglés', 'Ed. Física'],
      thursday: ['Ciencias', 'Historia', 'Matemáticas', 'Lenguaje', 'Arte'],
      friday: ['Inglés', 'Ed. Física', 'Matemáticas', 'Lenguaje', 'Ciencias']
    },
    classroom: 'Sala 201',
    active: true
  },
  {
    id: 2,
    name: '7° Básico B',
    level: '7° Básico',
    section: 'B',
    students: 30,
    homeRoomTeacher: {
      id: 7,
      name: 'Laura Mendoza'
    },
    subjects: [
      { id: 1, name: 'Matemáticas', teacherId: 6, hours: 6 },
      { id: 2, name: 'Lenguaje y Comunicación', teacherId: 7, hours: 6 },
      { id: 3, name: 'Ciencias Naturales', teacherId: 3, hours: 4 },
      { id: 4, name: 'Historia y Geografía', teacherId: 8, hours: 4 },
      { id: 5, name: 'Inglés', teacherId: 9, hours: 4 },
      { id: 6, name: 'Educación Física', teacherId: 10, hours: 3 },
      { id: 7, name: 'Arte', teacherId: 11, hours: 2 }
    ],
    classroom: 'Sala 202',
    active: true
  },
  {
    id: 3,
    name: '8° Básico A',
    level: '8° Básico',
    section: 'A',
    students: 28,
    homeRoomTeacher: {
      id: 6,
      name: 'Pedro Santander'
    },
    subjects: [
      { id: 1, name: 'Matemáticas', teacherId: 6, hours: 6 },
      { id: 2, name: 'Lenguaje y Comunicación', teacherId: 7, hours: 6 },
      { id: 3, name: 'Ciencias Naturales', teacherId: 3, hours: 4 },
      { id: 4, name: 'Historia y Geografía', teacherId: 8, hours: 4 },
      { id: 5, name: 'Inglés', teacherId: 9, hours: 4 },
      { id: 6, name: 'Educación Física', teacherId: 10, hours: 3 },
      { id: 7, name: 'Arte', teacherId: 11, hours: 2 }
    ],
    classroom: 'Sala 301',
    active: true
  },
  {
    id: 4,
    name: '1° Medio A',
    level: '1° Medio',
    section: 'A',
    students: 35,
    homeRoomTeacher: {
      id: 8,
      name: 'Roberto Fuentes'
    },
    subjects: [
      { id: 1, name: 'Matemáticas', teacherId: 6, hours: 6 },
      { id: 2, name: 'Lenguaje y Comunicación', teacherId: 7, hours: 6 },
      { id: 3, name: 'Biología', teacherId: 3, hours: 3 },
      { id: 4, name: 'Física', teacherId: 6, hours: 3 },
      { id: 5, name: 'Química', teacherId: 12, hours: 3 },
      { id: 6, name: 'Historia', teacherId: 8, hours: 4 },
      { id: 7, name: 'Inglés', teacherId: 9, hours: 4 },
      { id: 8, name: 'Educación Física', teacherId: 10, hours: 2 }
    ],
    classroom: 'Sala 401',
    active: true
  },
  {
    id: 5,
    name: '1° Medio B',
    level: '1° Medio',
    section: 'B',
    students: 33,
    homeRoomTeacher: {
      id: 7,
      name: 'Laura Mendoza'
    },
    subjects: [
      { id: 1, name: 'Matemáticas', teacherId: 6, hours: 6 },
      { id: 2, name: 'Lenguaje y Comunicación', teacherId: 7, hours: 6 },
      { id: 3, name: 'Biología', teacherId: 3, hours: 3 },
      { id: 4, name: 'Física', teacherId: 6, hours: 3 },
      { id: 5, name: 'Química', teacherId: 12, hours: 3 },
      { id: 6, name: 'Historia', teacherId: 8, hours: 4 },
      { id: 7, name: 'Inglés', teacherId: 9, hours: 4 },
      { id: 8, name: 'Educación Física', teacherId: 10, hours: 2 }
    ],
    classroom: 'Sala 402',
    active: true
  },
  {
    id: 6,
    name: '2° Medio A',
    level: '2° Medio',
    section: 'A',
    students: 32,
    homeRoomTeacher: {
      id: 6,
      name: 'Pedro Santander'
    },
    subjects: [
      { id: 1, name: 'Matemáticas', teacherId: 6, hours: 6 },
      { id: 2, name: 'Lenguaje y Comunicación', teacherId: 7, hours: 6 },
      { id: 3, name: 'Biología', teacherId: 3, hours: 3 },
      { id: 4, name: 'Física', teacherId: 6, hours: 3 },
      { id: 5, name: 'Química', teacherId: 12, hours: 3 },
      { id: 6, name: 'Historia', teacherId: 8, hours: 4 },
      { id: 7, name: 'Inglés', teacherId: 9, hours: 4 },
      { id: 8, name: 'Tecnología', teacherId: 10, hours: 2 }
    ],
    classroom: 'Sala 501',
    active: true
  }
];

export const mockSubjects = [
  {
    id: 1,
    name: 'Matemáticas',
    department: 'Matemáticas',
    description: 'Desarrollo del pensamiento lógico-matemático',
    color: '#3B82F6',
    icon: 'calculator'
  },
  {
    id: 2,
    name: 'Lenguaje y Comunicación',
    department: 'Lenguaje',
    description: 'Desarrollo de competencias comunicativas',
    color: '#10B981',
    icon: 'book-open'
  },
  {
    id: 3,
    name: 'Ciencias Naturales',
    department: 'Ciencias',
    description: 'Comprensión del mundo natural',
    color: '#8B5CF6',
    icon: 'beaker'
  }
];

export const mockMessages = [
  {
    id: 1,
    from: { id: 3, name: 'María José Rodríguez', role: 'profesor' },
    to: { id: 5, name: 'Patricia Elena Morales', role: 'apoderado' },
    subject: 'Avance del proyecto de Ecosistemas Marinos',
    message: 'Estimada Patricia, quería informarle sobre el excelente desempeño de Carlos en el proyecto actual.',
    timestamp: '2024-10-15T14:30:00.000Z',
    read: false,
    priority: 'normal'
  }
];

export const mockEvaluations = [
  {
    id: 1,
    title: 'Evaluación Ecosistemas Marinos',
    projectId: 1,
    subjectId: 3,
    type: 'proyecto',
    weight: 30,
    maxScore: 100,
    dueDate: '2024-10-25T23:59:00.000Z',
    instructions: 'Presentar investigación sobre ecosistemas marinos locales',
    rubric: [
      { criteria: 'Investigación', weight: 40, description: 'Calidad y profundidad de la investigación' },
      { criteria: 'Presentación', weight: 30, description: 'Claridad y organización de la presentación' },
      { criteria: 'Trabajo en equipo', weight: 30, description: 'Colaboración efectiva' }
    ],
    status: 'active'
  }
];

export const mockPayments = [
  {
    id: 1,
    studentId: 4,
    studentName: 'Carlos Eduardo Silva',
    parentId: 5,
    parentName: 'Patricia Elena Morales',
    concept: 'Mensualidad Octubre 2024',
    amount: 85000,
    dueDate: '2024-10-05T23:59:00.000Z',
    paidDate: '2024-10-03T10:15:00.000Z',
    status: 'paid',
    method: 'transferencia',
    transactionId: 'TXN-20241003-001'
  }
];

export const mockCalendarEvents = [
  {
    id: 1,
    title: 'Presentación Ecosistemas Marinos',
    description: 'Presentaciones finales del proyecto ABP',
    start: '2024-10-28T09:00:00.000Z',
    end: '2024-10-28T11:00:00.000Z',
    type: 'academic',
    course: '7° Básico A',
    location: 'Sala 201',
    attendees: ['profesor', 'alumno']
  }
];

export const roles = {
  administrador: {
    name: 'Administrador',
    permissions: ['all'],
    description: 'Acceso completo al sistema',
    color: 'purple'
  },
  gestor: {
    name: 'Gestor',
    permissions: ['users', 'courses', 'projects', 'calendar', 'reports'],
    description: 'Gestión académica y administrativa',
    color: 'blue'
  },
  profesor: {
    name: 'Profesor',
    permissions: ['projects', 'evaluations', 'messages', 'grades'],
    description: 'Gestión de clases y evaluaciones',
    color: 'green'
  },
  alumno: {
    name: 'Alumno',
    permissions: ['projects', 'grades', 'messages'],
    description: 'Acceso a contenido educativo',
    color: 'yellow'
  },
  apoderado: {
    name: 'Apoderado',
    permissions: ['messages', 'payments', 'reports', 'grades'],
    description: 'Seguimiento académico y financiero',
    color: 'orange'
  }
};

export const permissions = {
  all: 'Acceso total',
  users: 'Gestión de usuarios',
  courses: 'Gestión de cursos',
  projects: 'Proyectos',
  evaluations: 'Evaluaciones',
  messages: 'Mensajería',
  grades: 'Notas y calificaciones',
  calendar: 'Calendario escolar',
  payments: 'Pagos y finanzas',
  reports: 'Reportes'
};

export const projectStatuses = {
  planificado: {
    name: 'Planificado',
    color: 'gray',
    description: 'Proyecto en fase de planificación'
  },
  activo: {
    name: 'Activo',
    color: 'green',
    description: 'Proyecto en desarrollo'
  },
  pausado: {
    name: 'Pausado',
    color: 'yellow',
    description: 'Proyecto temporalmente pausado'
  },
  completado: {
    name: 'Completado',
    color: 'blue',
    description: 'Proyecto finalizado exitosamente'
  },
  cancelado: {
    name: 'Cancelado',
    color: 'red',
    description: 'Proyecto cancelado'
  }
};

export const deliverableStatuses = {
  pending: {
    name: 'Pendiente',
    color: 'gray',
    description: 'Por entregar'
  },
  'in-progress': {
    name: 'En Progreso',
    color: 'blue',
    description: 'En desarrollo'
  },
  completed: {
    name: 'Completado',
    color: 'green',
    description: 'Entregado'
  },
  overdue: {
    name: 'Atrasado',
    color: 'red',
    description: 'Entrega tardía'
  },
  reviewed: {
    name: 'Revisado',
    color: 'purple',
    description: 'Evaluado por el profesor'
  }
};

export const paymentStatuses = {
  pending: {
    name: 'Pendiente',
    color: 'yellow',
    description: 'Pago pendiente'
  },
  paid: {
    name: 'Pagado',
    color: 'green',
    description: 'Pago realizado'
  },
  overdue: {
    name: 'Vencido',
    color: 'red',
    description: 'Pago vencido'
  },
  partial: {
    name: 'Parcial',
    color: 'orange',
    description: 'Pago parcial'
  }
};

export const eventTypes = {
  academic: {
    name: 'Académico',
    color: 'blue',
    icon: 'academic-cap'
  },
  administrative: {
    name: 'Administrativo',
    color: 'gray',
    icon: 'clipboard-document-list'
  },
  extracurricular: {
    name: 'Extracurricular',
    color: 'green',
    icon: 'star'
  },
  meeting: {
    name: 'Reunión',
    color: 'purple',
    icon: 'users'
  },
  exam: {
    name: 'Evaluación',
    color: 'red',
    icon: 'document-text'
  },
  holiday: {
    name: 'Feriado',
    color: 'yellow',
    icon: 'sun'
  }
};

// Funciones de utilidad para trabajar con los datos mock
export const getUsersByRole = (role) => {
  return mockUsers.filter(user => user.role === role && user.active);
};

export const getUserById = (id) => {
  return mockUsers.find(user => user.id === parseInt(id));
};

export const getCourseById = (id) => {
  return mockCourses.find(course => course.id === parseInt(id));
};

export const getSubjectById = (id) => {
  return mockSubjects.find(subject => subject.id === parseInt(id));
};

export const getProjectsByStatus = (status) => {
  // Esta función sería implementada cuando tengamos los datos de proyectos
  return [];
};

export const getStatusConfig = (type, status) => {
  const statusMaps = {
    project: projectStatuses,
    deliverable: deliverableStatuses,
    payment: paymentStatuses
  };
  
  return statusMaps[type]?.[status] || { name: status, color: 'gray' };
};

export const formatUserRole = (role) => {
  return roles[role]?.name || role;
};

export const getUserPermissions = (role) => {
  return roles[role]?.permissions || [];
};

export const hasPermission = (userRole, permission) => {
  const userPermissions = getUserPermissions(userRole);
  return userPermissions.includes('all') || userPermissions.includes(permission);
};

// Generadores de datos de ejemplo
export const generateMockStudents = (courseId, count = 30) => {
  const firstNames = ['Ana', 'Carlos', 'María', 'José', 'Francisca', 'Matías', 'Sofía', 'Diego', 'Valentina', 'Sebastián'];
  const lastNames = ['González', 'Rodríguez', 'Muñoz', 'Silva', 'López', 'Martínez', 'Pérez', 'Fernández', 'Morales', 'Torres'];
  
  return Array.from({ length: count }, (_, index) => ({
    id: 1000 + courseId * 100 + index,
    name: `${firstNames[index % firstNames.length]} ${lastNames[index % lastNames.length]}`,
    rut: `${20000000 + index}.${Math.floor(Math.random() * 10)}.${Math.floor(Math.random() * 10)}-${Math.floor(Math.random() * 10)}`,
    email: `estudiante${index + 1}@educapp.cl`,
    courseId: courseId,
    active: true
  }));
};

export const generateMockGrades = (studentId, subjectId, evaluations = 5) => {
  return Array.from({ length: evaluations }, (_, index) => ({
    id: studentId * 1000 + subjectId * 100 + index,
    studentId,
    subjectId,
    evaluationId: index + 1,
    score: Math.floor(Math.random() * 3) + 4.0 + Math.random(), // Notas entre 4.0 y 7.0
    date: new Date(2024, 9, index * 5 + 1).toISOString(),
    type: ['prueba', 'proyecto', 'tarea', 'participacion'][index % 4]
  }));
};

export const schoolConfig = {
  name: 'Colegio ABP360',
  address: 'Av. Educación 1234, Santiago, Chile',
  phone: '+56 2 2345 6789',
  email: 'contacto@abp360.cl',
  website: 'www.abp360.cl',
  logo: '/assets/logo.png',
  primaryColor: '#0ea5e9',
  secondaryColor: '#64748b',
  academicYear: '2024',
  startDate: '2024-03-01',
  endDate: '2024-12-15',
  periods: [
    { id: 1, name: '1er Semestre', start: '2024-03-01', end: '2024-07-15' },
    { id: 2, name: '2do Semestre', start: '2024-08-01', end: '2024-12-15' }
  ]
};
